module.exports = __webpack_public_path__ + "img/命运.5cba9409.png";